// @ts-nocheck
import { IconPresentationProps } from "@insite/mobius/Icon";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { TextSeparatorPresentationProps } from "@store/Library/Components/Toolkit/TextSeparator";
import { boxStyles } from "@store/Themes/common/mixins/box";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

interface SignInSharedProps {
    wrapper?: InjectableCss;
    title?: TypographyPresentationProps;
    icon?: IconPresentationProps;
}

export interface SignInProps extends SignInSharedProps {
    separator?: TextSeparatorPresentationProps;
    overlayOverrides?: SignInSharedProps;
}

export const signInProps: SignInProps = {
    wrapper: {
        css: css`
            ${boxStyles(pxToRemArray([20, null, null, 25, 30]))};
            font-size: ${x => x.theme.design.typography.size.smaller};

            ${breakpoint("md")} {
                height: 100%;
            }
        `,
    },
    title: {
        variant: "h4",
        forwardAs: "h2",
        css: css`
            margin-top: 0;
        `,
    },
    icon: {
        color: "primary", // Store Custom Code
        size: 60,
        css: spacingStyles(null, pxToRem(10)),
    },
    separator: {
        spacing: pxToRemArray([16]),
        extendedStyles: {
            text: {
                css: css`
                    font-size: ${x => x.theme.design.typography.size.smaller};
                    font-weight: ${x => x.theme.design.typography.weight.bold};
                    line-height: ${x => x.theme.design.typography.lineHeight.small};
                `,
            },
        },
    },
    overlayOverrides: {
        title: {
            forwardAs: "p",
            css: css`
                font-size: ${x => x.theme.design.typography.size.large} !important;
            `,
        },
    },
};
